<template>
  <div class="flex items-center gap-spacing_1">
    <p class="label" :class="{ '!text-neutral-500': disabled }">
      {{ label }}
    </p>

    <span
      v-if="required"
      class="astrict"
      :class="{ '!text-neutral-500': disabled }"
    >
      *
    </span>

    <CommonUIcons
      class="icon"
      :name="icon_name"
      :class="{ '!text-neutral-500': disabled }"
    />

    <p
      v-if="optional"
      class="optional"
      :class="{ '!text-neutral-500': disabled }"
    >
      (Optional)
    </p>
  </div>
</template>

<script setup lang="ts">
import type { LabelProps } from "~/types/schemas/common/Atom/label";

defineProps<LabelProps>();
</script>

<style scoped>
.label {
  @apply font-secondary text-size_4 font-medium text-neutral-800;
}

.astrict {
  @apply text-errors;
}

.icon {
  @apply h-icon_size_3 w-icon_size_3 text-neutral-600;
}

.optional {
  @apply font-semibold text-neutral-600;
}
</style>
